/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

// Chart (top) + X-axis row (bottom), filling the area given by the parent.
export const ChartColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

// Positioned wrapper around the plot so the vertical today marker can overlay it.
export const PlotWrap = styled(Box)({
  position: 'relative',
  width: '100%',
});

// Vertical "today" marker — 1px, on-surface (Figma node 9335:7823 Divider vertical, On-surface).
// `left` is set per-render via sx. pointer-events none so it never blocks chart hover/tooltip.
export const TodayLine = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: 1,
  backgroundColor: theme.palette.semantic_dark?.surface.onSurface,
  pointerEvents: 'none',
}));

// X-axis strip — start label left, end label right (Figma node 10282:123068 calendar, h 14).
// position: relative so the absolutely-placed today label can sit at its X position.
export const AxisRow = styled(Box)({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  height: 14,
  flexShrink: 0,
});

// Period start / end date label — Roboto 12/14 regular, muted (Figma --surface/on-surface-muted).
export const AxisLabel = styled(Typography)(({theme}) => ({
  fontSize: 12,
  lineHeight: '14px',
  fontWeight: 400,
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
  whiteSpace: 'nowrap',
}));

// Today's date label — same size, but brighter (on-surface) and positioned at today's X (`left`
// via sx, centered on the marker).
export const AxisTodayLabel = styled(Typography)(({theme}) => ({
  position: 'absolute',
  top: 0,
  transform: 'translateX(-50%)',
  fontSize: 12,
  lineHeight: '14px',
  fontWeight: 400,
  color: theme.palette.semantic_dark?.surface.onSurface,
  whiteSpace: 'nowrap',
}));
